import React, { useState, useEffect, useRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {
  ImageUploadContainer,
  Input,
  Label,
  PreviewImage,
  Button,
  Wrapper,
  SubLabelWrapper,
  InputColumn,
  PreviewImagesContainer,
  FindImageButton,
  MobileLabel,
  //ErrorMessage,
} from './styled';
import { ReactComponent as UploadIcon } from 'assets/icons/upload-icon-gray.svg';
import { ReactComponent as ImageSearchIconO } from 'assets/icons/image-icon-orange.svg';
import { ReactComponent as CameraIconO } from 'assets/icons/camera-icon-o.svg';
import { ReactComponent as CleanSignIcon } from 'assets/icons/X-white.svg';
import { ReactComponent as ImageSearchIconG } from 'assets/icons/images-icon-gray.svg';
import { ReactComponent as CameraIconG } from 'assets/icons/camera-icon-gray.svg';
import { createErrorToast } from 'utils/createToast';
import { Toast } from 'components/Toast';

const MAX_IMAGES = 3;

const ImageUpload = ({ inputName, isMobile = false, isRequired = false }) => {
  const [toastList, setToastList] = useState([]);
  const { control, setValue } = useFormContext();
  const [previewUrls, setPreviewUrls] = useState([]);
  const [files, setFiles] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);
  const handleFiles = selectedFiles => {
    if (selectedFiles.length === 0) return;

    // Verifica se ao adicionar os novos arquivos ultrapassaria o limite
    if (files.length + selectedFiles.length > MAX_IMAGES) {
      createErrorToast(setToastList, 'Somente 3 imagens podem ser adicionadas');
      return;
    }

    const newFiles = Array.from(selectedFiles).slice(0, MAX_IMAGES - files.length);

    // Criar URLs para pré-visualização
    const newPreviewUrls = newFiles.map(file => URL.createObjectURL(file));

    setFiles(prev => [...prev, ...newFiles]);
    setPreviewUrls(prev => [...prev, ...newPreviewUrls]);
  };

  const handleFileChange = event => {
    handleFiles(event.target.files);
    event.target.value = null;
  };

  const handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    handleFiles(event.dataTransfer.files);
  };

  const handleRemoveImage = index => {
    setPreviewUrls(prevUrls => prevUrls.filter((_, i) => i !== index));
    setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (isRequired && files.length === 0) {
      setValue(inputName, null);
    } else {
      setValue(inputName, files);
    }
  }, [files, inputName, setValue, isRequired]);

  useEffect(() => {
    return () => {
      previewUrls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [previewUrls]);

  return (
    <>
      <Controller
        name={inputName}
        control={control}
        defaultValue={[]}
        rules={isRequired ? { required: 'Adicione ao menos uma foto' } : {}}
        render={() => (
          <Wrapper isRequired={isRequired}>
            {!isMobile ? (
              <h5>{`(Adicione até ${MAX_IMAGES} fotos)`}</h5>
            ) : (
              <h6>{`Adicione até ${MAX_IMAGES} fotos`}</h6>
            )}
            <div>
              {previewUrls.length < MAX_IMAGES && (
                <InputColumn>
                  <ImageUploadContainer
                    borderDashed={true}
                    onDragOver={event => {
                      event.preventDefault();
                      setDragActive(true);
                    }}
                    onDragLeave={() => setDragActive(false)}
                    onDrop={handleDrop}
                    className={`drop-zone ${dragActive ? 'active' : ''}`}
                  >
                    <Input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                      id={`fileInput-${inputName}`}
                      aria-label="Carregar imagens"
                    />
                    <MobileLabel htmlFor={`fileInput-${inputName}`}>
                      <ImageSearchIconG />
                      Escolher na galeria
                    </MobileLabel>
                    <Label htmlFor={`fileInput-${inputName}`}>
                      <div>
                        <UploadIcon />
                      </div>
                      Arraste fotos aqui, ou...
                      <SubLabelWrapper>
                        <FindImageButton onClick={() => fileInputRef.current?.click()}>
                          <ImageSearchIconO />
                          Busque arquivos
                        </FindImageButton>
                      </SubLabelWrapper>
                    </Label>
                  </ImageUploadContainer>
                  {isMobile && (
                    <ImageUploadContainer borderDashed={false}>
                      <Input
                        disabled={!isMobile}
                        id="cameraInput"
                        type="file"
                        accept="image/*"
                        capture="environment"
                        onChange={handleFileChange}
                      />
                      <MobileLabel htmlFor="cameraInput">
                        <CameraIconG />
                        Tirar foto
                      </MobileLabel>
                      <Label htmlFor="cameraInput">
                        <div>
                          <CameraIconO />
                        </div>
                        Ou tire uma foto se preferir
                      </Label>
                    </ImageUploadContainer>
                  )}
                </InputColumn>
              )}
              <PreviewImagesContainer fotosSize={isMobile && previewUrls.length < 3 ? '147px' : '93px'}>
                {previewUrls.map((url, index) => (
                  <div key={index}>
                    <PreviewImage src={url} alt={`Preview da Imagem ${index + 1}`} />
                    <Button onClick={() => handleRemoveImage(index)}>
                      <CleanSignIcon />
                    </Button>
                  </div>
                ))}
              </PreviewImagesContainer>
            </div>
          </Wrapper>
        )}
      />
      <Toast toastList={toastList} autoDelete dismissTime={5000} />
    </>
  );
};

export default ImageUpload;
